import type { JAccordionLike } from '@journey/ui-kit'
import { defineAsyncComponent, markRaw } from 'vue'

export const LOYALTY_MANAGE_POINTS_ACCORDION_ITEMS: Array<JAccordionLike> = [
  {
    title: 'loyalty.managePointsItems.buyPoints',
    content: markRaw(
      defineAsyncComponent(
        () =>
          import(
            '@/modules/Loyalty/components/LoyaltyManagePoints/LoyaltyManagePointsBuyPoints/LoyaltyManagePointsBuyPoints.vue'
          )
      )
    ),
  },
  {
    title: 'loyalty.managePointsItems.transferPoints',
    content: markRaw(
      defineAsyncComponent(
        () =>
          import(
            '@/modules/Loyalty/components/LoyaltyManagePoints/LoyaltyManagePointsTransferPoints/LoyaltyManagePointsTransferPoints.vue'
          )
      )
    ),
  },
  {
    title: 'loyalty.managePointsItems.requestCredit',
    content: markRaw(
      defineAsyncComponent(
        () =>
          import(
            '@/modules/Loyalty/components/LoyaltyManagePoints/LoyaltyManagePointsRequestCredit/LoyaltyManagePointsRequestCredit.vue'
          )
      )
    ),
  },
]
